//Version 2 updated 5/31/20
class Valuation {
  constructor(symbol, fmp, ivv, reuters) {
    this.symbol = symbol

    // Defaults
    this.erp1 = reuters.ERP1
    this.erp2 = reuters.ERP2
    this.rf1 = reuters.Rf1
    this.rf2 = reuters.Rf2
    this.years = 5
    this.degreeReversionMarketImpliedEarningsGrowth = .4
    this.degreeReversionMarketImpliedFutureSales = .4
    this.ir_SP500 = .075;
    this.sP500_g = .07;
    this.sP500_pm = 7.1;
    this.sP500_pe = 15.7;
    this.rm_Mean = .10;
    this.rm_StdDev = .10;
  

    this.dynamicOps = reuters.DynamicOps; //CalculatedCols! DynamicOps
    this.degreeReversion_Beta2 = 0

    if (this.dynamicOps === 0) {
      this.degreeReversion_Beta2 = .5; //stable
    } else {
      this.degreeReversion_Beta2 = 1;  //dynamic
    }

    

    this.iBeta = reuters.ibeta;
    this.regressedBeta = reuters.beta;
    this.currentPrice = fmp.price || 0; 
    this.recentPrice = reuters.price;
    this.currentSales = reuters.sales_y1;
    this.eps = reuters.eps_ey0;
    this.payout = reuters.PayoutAvgCompany;
    this.yearFrac = reuters.YearFrac;
    this.industryG = this.SalesGrowthStepAlign(this.round(reuters.Industry_gs, 2));
    this.industryPM = this.round(reuters.Industry_PM,3);
    this.industryPE = this.round(reuters.NormalizedFuturePE,1);  //05/13/20 Brian changed the source field from Avg. Ind.
    this.numAnalysts = reuters.epsn_eg5;
    this.analystsGrowth = reuters.eps_eg5/100;
    this.highGrowth = reuters.epsh_eg5 / 100;  // *Must divide number by 100
    this.lowGrowth = reuters.epsl_eg5 / 100; // *Must divide number by 100
    this.lastMonthGrowth = reuters.epspm_eg5 / 100;  //*Must divide number by 100
    this.g1 = reuters.eps_eg5 / 100; //reuters.eps_eg5; // *Must divide number by 100
    this.currentShares = reuters.shr_ay1; //reuters.shr_ay1;
    this.currentPM = reuters.npm_y1; //reuters.npm_y1;
    this.futurePM = this.round(reuters.FuturePM,3); //reuters.FuturePM;
    this.historicalShares = [[1,reuters.shr_ay3], [2,reuters.shr_ay2], [3,reuters.shr_ay1]]
    this.historicalSales = [[1, reuters.sales_y3], [2, reuters.sales_y2], [3, reuters.sales_y1]]
    this.price13W = reuters.price_13w;
    this.price13WIVV = reuters.price_13w_ivv;
    this.currentPriceIVV = ivv.price;
    //this.futureShares = reuters.futureShares;
    this.shrTrend = reuters.ShrTrend;
    this.extrapSales = reuters.extrapsales;
    this.SalesRecentg = this.SalesGrowthStepAlign(this.round(reuters.SalesRecentg,2));
    this.CompanyPMAvg = this.round(reuters.CompanyPMAvg,3);
    this.PEAvgCompany = this.round(reuters.PEAvgCompany,1);
    this.ReversionGrowth = reuters.ReversionGrowth;
    this.NormalizedCurrentPM = reuters.NormalizedCurrentPM;
    this.PriceTrend = reuters.PriceTrend;
    this.SalesTrend = reuters.SalesTrend;  //added this and PriceTrend on 2/19/23 for new Trend line in graphs
    this.PriceYoY = reuters.PriceYoY;
    this.SalesYoY = reuters.SalesYoY;  //added this and PriceYoY on 3/1/23 for new Trend line in graphs
    this.futurePE = reuters.futurepe ;// added this on 4/29/23
    this.CoEFuturePE = reuters.CoEFuturePE //added this on 9/15/23
    
    //Buy Range Modules
    this.planPriceDispersion = null;
    this.highSideAmplifier = null;
    this.indexedPlanPrice = null;
    this.midpointPrice = null;
    this.priceTolerance = null;
    this.TransitionPrice7 = null;
    this.TransitionPrice6 = null;
    this.TransitionPrice5 = null;
    this.TransitionPrice4 = null;
    this.TransitionPrice3 = null;
    this.TransitionPrice2 = null;
    this.TransitionPrice1 = null;
    this.TransitionPriceS = null;
    this.TransitionPriceE = null;

    
    // Certainty sliders
    this.practicalRiskFactor = null;
    this.theoreticalRiskFactor = null;
    //this.practicalGrowthFactor = null;
    //this.theoreticalGrowthFactor = null;
    this.userGrowthFactor = null;
    this.userPMFactor = null;
    this.userPEFactor = null;
    

    // Graph data
    this.irPotentialGrowthGraphData = [];
    this.irPracticalGrowthGraphData = [];
    this.irSP500GrowthGraphData = [];
    this.practicalGrowthGraphData = [];
    this.potentialGrowthGraphData = [];
    this.sp500GrowthGraphData = [];
    this.PriceTrendGraphData = [];
    this.SalesTrendGraphData = [];
    this.PriceYoYGraphData = [];
    this.SalesYoYGraphData = [];
  }

  roundedValuation() {
    // FORMULAS
    var plowback = 1 - this.payout;
    var beta1 = this.round(this.Beta(this.regressedBeta, .33, 1),1); //Note:The last variable passed in Beta function is RB --Reversion Beta or target beta; in stage1 it is the market beta (=1); in stage2 it is ibeta (industry beta)
    var beta2 = this.Beta(this.round(beta1,1), this.degreeReversion_Beta2, this.iBeta);
    var ra1 = this.Ra(beta1, this.erp1, this.rf1);
    //var ra1 = this.Ra(this.round(beta1,1), this.erp1, this.rf1);
    var ra2 = this.Ra(beta2, this.erp2, this.rf2);
    //var futurePE = this.round(((1 + ra2) / ra2),1);  // 4/29/23 change. now pulling futurePE from reuters database
    
    // ************ 04/30/20 added user PM Factor logic here ***************
    // ************ 05/07/20 added user PE Factor logic here ***************
    
    var valuationPM = this.futurePM;
    var valuationPE = this.futurePE; //4/29/23 change. now pulling futurePE from reuters database

    this.futurePMDefault = valuationPM;
    this.futurePEDefault = valuationPE;
  
    if (this.userPMFactor) {
      valuationPM = this.round(this.userPMFactor,3);
    }

    if (this.userPEFactor){
      valuationPE = this.userPEFactor;
    }

    this.futurePM = valuationPM;
    this.futurePMFactor = valuationPM;  

    this.futurePE = valuationPE;
    this.futurePEFactor = valuationPE;

// *******************************************    
    
    var gm = ((((this.currentPrice - (this.years * this.eps * this.payout)) * ((1 + ra1) ** this.years)) / (this.eps * this.futurePE)) ** (1 / (this.years + this.yearFrac))) - 1;
    
    // SINGLE VALUATION MODULE (Stable or Dynamic)

    var growthTimeSpan;
    growthTimeSpan = this.years + (1 + this.yearFrac);
    var futureShares = this.currentShares * ((1 + this.shrTrend) ** growthTimeSpan);

    // Initialize variables for looping
    var i, y;
    
    //FUTURE SALES
    var dampenGrowth,
      gi,
      eps0,
      perAnnGrowthSales,
      futureSales,
      marketImpliedFutureSales,
      marketImpliedSalesGrowth;

      marketImpliedFutureSales = (this.currentPrice - (this.years * this.eps * this.payout)) * (1/this.futurePE) * ((1 + ra1) ** this.years) * (futureShares / this.futurePM);
      marketImpliedSalesGrowth = ((marketImpliedFutureSales/this.currentSales)**(1/growthTimeSpan))-1;
    
      if (this.dynamicOps === 0) { //Stable company
      dampenGrowth = this.Dampen_EarningsGrowth(this.g1, plowback, this.numAnalysts, this.lowGrowth, this.highGrowth, this.lastMonthGrowth, gm, this.eps, -this.shrTrend, ra1, this.ReversionGrowth);
      gi = dampenGrowth;
      eps0 = this.eps * ((1 + gi) ** this.yearFrac) //  Beta estimated right now at time zero
      futureSales = eps0 * ((1 + gi) ** this.years) * (futureShares / this.futurePM);
      perAnnGrowthSales = ((futureSales / this.currentSales) ** (1 / growthTimeSpan)) - 1;

    } else { //1=Dynamic company
      futureSales = (this.degreeReversionMarketImpliedFutureSales * marketImpliedFutureSales) + ((1 - this.degreeReversionMarketImpliedFutureSales) * this.extrapSales);
      perAnnGrowthSales = ((futureSales / this.currentSales) ** (1 / growthTimeSpan)) - 1;
    
    } // end if for Stable versus Dynamic Future Sales Calculation
    
    perAnnGrowthSales = this.round(perAnnGrowthSales,2);
    

    // VALUATION
  
    // var futureEPS = (futureSales / futureShares * this.futurePM);

    /* stage1 calculates the present value of dividends.  This accounts for <20% total valuation */
    // var stage1 = this.eps * this.payout * this.years;

    /* stage2 valuation calculates the present value of future earnings.  This accounts for 80% of valuation */
    // var stage2 = (futureEPS * futurePE) / ((1 + ra1) ** this.years);

    // FINAL valuation
    // var preciseValuation = stage1 + stage2; // don't use this variable.

    // BUY RANGE MODULE
    
    var valuationB = this.round(beta1, 1); //because of rounding, Ra1 different than the Cost of Capital showin in Company Info section
    var priceB = valuationB;   //Polaris "un"Certainty Factor - Certainty Slider comes into the code at this point/variable!!
    this.theoreticalRiskFactor = valuationB;

    // var TickU4_b = priceB + .4;
    var TickU2_b = this.round(priceB + .2, 2);
    // var Tick0_b = priceB;
    var TickD2_b = this.round(priceB - .2, 2);
    // var TickD4_b = priceB - .4;

    var valuationRa1 = this.Ra(valuationB, this.erp1, this.rf1);
    this.priceRa1 = this.Ra(priceB, this.erp1, this.rf1);

    /*
    8/24/17. For stable companies (ie: JNJ, PG), it is assumed Beta values will continue to be somewhat unique to company,
    only slightly nudging closer to iBeta in Stage2. As Risk slider is moved, Beta2 and downstream variables Ra2
    and PE Future change.

    For dynamic companies (ie: AMZN, TSLA), it is assumed Beta values will completely regress to
    iBeta in Stage2. As Risk slider is moved, Beta2 and downstream variables Ra2 and PE Future don't change.

    Variable degreeReversion_Beta2 is set earlier in code. Therefore, IF statement not needed below.
    */
  
    var valuationG = this.SalesGrowthStepAlign(perAnnGrowthSales)

    this.theoreticalGDefault = valuationG;

    if (this.userGrowthFactor) {
      valuationG = this.SalesGrowthStepAlign(this.round(this.userGrowthFactor, 2)); //IMPORTANT: User Growth Factor - Growth Slider comes into the code as this point/variable!!
    }

    this.theoreticalGrowthFactor = valuationG;  //sales growth associated with theoretical valuation
    
    var intraYearSales;
    intraYearSales = this.currentSales * ((1 + valuationG)**(1 + this.yearFrac));

// Rounded Valuation

    var roundedFutureSales = ((intraYearSales * (( 1 + valuationG ) ** this.years)));
    var dividends =  ((this.years) * (this.eps) * (this.payout));
    var roundedValuation = ((roundedFutureSales / futureShares) * (this.futurePM)) * this.futurePE / ((1 + valuationRa1) ** this.years) + dividends; 

    var priceRangeStep;
    
    if (Math.abs(valuationG) > .3) {
      
      priceRangeStep = .03;
    
    } else if (Math.abs(valuationG) > .15) {
    
      priceRangeStep = .02 ;
    
    }  else {  priceRangeStep = .01
    
    }
    
    this.priceG = this.BuyRange_Price_g(this.currentPrice, this.priceRa1, this.futurePE, this.eps, this.years, this.payout, intraYearSales, futureShares, this.futurePM, valuationG, priceRangeStep);
    
    var TickU4_g = this.round(this.priceG + (4 * priceRangeStep),2);
    var TickU2_g = this.round(this.priceG + (2 * priceRangeStep),2);
    var Tick0_g = this.round(this.priceG + (0 * priceRangeStep),2);
    var TickD2_g = this.round(this.priceG + (-2 * priceRangeStep),2);
    var TickD4_g = this.round(this.priceG + (-4 * priceRangeStep),2);

    // Determine Buy Range
    var L_BuyRange_b,
      H_BuyRange_b,
      Tick0Adj_g,
      L_BuyRange_g,
      H_BuyRange_g,
      L_BuyRange_Ra1,
      H_BuyRange_Ra1,
      L_BuyRange_Valuation,
      H_BuyRange_Valuation,
      L_BuyRange,
      // P_BuyRange,
      H_BuyRange,
      practicalValuation,
      practicalG;

    if (this.currentPrice < roundedValuation) {
      L_BuyRange_b = TickU2_b;
      H_BuyRange_b = TickD2_b;

      if (valuationG <= TickU4_g) {
        Tick0Adj_g = Tick0_g;
      } else {
        Tick0Adj_g = TickU4_g;
      }

      if (Tick0Adj_g === Tick0_g) {
        L_BuyRange_g = Math.min(TickU2_g,TickD2_g);
      } else {
        L_BuyRange_g = Math.min(TickU4_g,Tick0_g);
      }
 
      if (Tick0Adj_g === Tick0_g) {
        H_BuyRange_g =Math.max(TickU2_g,TickD2_g);
      } else {
        H_BuyRange_g = Math.min(valuationG - (3 * priceRangeStep), Math.max(TickU4_g,Tick0_g));
      }

      L_BuyRange_Ra1 = this.Ra(L_BuyRange_b, this.erp1, this.rf1);
      H_BuyRange_Ra1 = this.Ra(H_BuyRange_b, this.erp1, this.rf1);

      L_BuyRange_Valuation = (((intraYearSales * ((1 + L_BuyRange_g) ** this.years) * (this.futurePM / futureShares) * this.futurePE)) / ((1 + L_BuyRange_Ra1) ** this.years)) + (this.years * this.eps * this.payout);

      H_BuyRange_Valuation = (((intraYearSales * ((1 + H_BuyRange_g) ** this.years) * (this.futurePM / futureShares) * this.futurePE)) / ((1 + H_BuyRange_Ra1) ** this.years)) + (this.years * this.eps * this.payout);

      L_BuyRange = Math.min(roundedValuation, L_BuyRange_Valuation);
      // P_BuyRange = this.currentPrice;
      H_BuyRange = Math.min(roundedValuation, H_BuyRange_Valuation);

      if (H_BuyRange === roundedValuation){
        practicalG = valuationG;
        practicalValuation = roundedValuation;
      } else {
        practicalG = H_BuyRange_g;
        practicalValuation = H_BuyRange;
      }

    } else {
      L_BuyRange_b = TickU2_b;
      H_BuyRange_b = TickD2_b;

      if (valuationG >= TickD4_g) {
        Tick0Adj_g = Tick0_g;
      } else {
        Tick0Adj_g = TickD4_g;
      }
      
      if (Tick0Adj_g === Tick0_g) {
        L_BuyRange_g = Math.min(TickU2_g,TickD2_g);
      } else {
        L_BuyRange_g = Math.max(valuationG + (3 * priceRangeStep), Math.min(Tick0_g,TickD4_g));
      }

      if (Tick0Adj_g === Tick0_g) {
        H_BuyRange_g = Math.max(TickU2_g,TickD2_g);
      } else {
        H_BuyRange_g = Math.max(Tick0_g,TickD4_g);
      }

      L_BuyRange_Ra1 = this.Ra(L_BuyRange_b, this.erp1, this.rf1);
      H_BuyRange_Ra1 = this.Ra(H_BuyRange_b, this.erp1, this.rf1);

      L_BuyRange_Valuation = (((intraYearSales * ((1 + L_BuyRange_g) ** this.years) * (this.futurePM / futureShares) * this.futurePE)) / ((1 + L_BuyRange_Ra1) ** this.years)) + (this.years * this.eps * this.payout);

      H_BuyRange_Valuation = (((intraYearSales * ((1 + H_BuyRange_g) ** this.years) * (this.futurePM / futureShares) * this.futurePE)) / ((1 + H_BuyRange_Ra1) ** this.years)) + (this.years * this.eps * this.payout);

      L_BuyRange = Math.max(roundedValuation, L_BuyRange_Valuation);
      // P_BuyRange = this.currentPrice;
      H_BuyRange = Math.max(roundedValuation, H_BuyRange_Valuation);

      if (L_BuyRange === roundedValuation){
        practicalG = valuationG;
        practicalValuation = roundedValuation;
      } else {
        practicalG = L_BuyRange_g;
        practicalValuation = L_BuyRange;
      }
    }

  //  ****** 06/10/20 6 new variables to add to watchlist 
 var pmGrowth,
 earningsGrowth,
 peMultiplier,
 futureR,
 futureCoE,
 futureEarningsGrowth,
 futureRf;
 
 // ** 05/06/21  Workaround for Watchlist when NormalizedCUrrentPM <= 0

 if (this.NormalizedCurrentPM <= 0) {
  pmGrowth = 0;
  earningsGrowth = 0;
} else {
  pmGrowth = ((this.futurePM/this.NormalizedCurrentPM)**(1/growthTimeSpan)) - 1; 
  earningsGrowth = (((1 + practicalG)*(1+pmGrowth))/(1+this.shrTrend)) - 1;
}

  //Note: FuturePM is the Future PM slider value.
 
  peMultiplier = (this.futurePE/this.futurePEDefault) - 1;
  //Note: FuturePE is the Future PE slider value
  futureR = (1+((2*(peMultiplier))/(1+peMultiplier))) * ra2;              
  futureCoE = ra2;
  futureEarningsGrowth = .33 * futureR;
  futureRf = this.rf2;


// GRAPHS and IR MODULE
    //Investment Return (Ir)

    /*8/28/17 If buyRange limited by roundedValuation, then use valuationRa1 associated with rounded valuation
    in investment return calculations.*/
    /*
    //* 06/04/18 Changed to valuationRa1 from irHighRa1 and irLowRa1 so these variables not needed
    var irLowRa1,
      irHighRa1

    if (L_BuyRange === roundedValuation) {
      irLowRa1 = valuationRa1
    } else {
      irLowRa1 = L_BuyRange_Ra1
    }
    if (H_BuyRange === roundedValuation) {
      irHighRa1 = valuationRa1
    } else {
      irHighRa1 = H_BuyRange_Ra1
    }
*/

/* 09/05/17  Note: The following represents an addition to a variable name convention. We started using potential, in places, instead of valuation.
This was done to clarify its use in the UI.
To compound things, we later use the word theoretical. SO valuation=potential=theoretical=rounded.
We need to change all the code to theoretical.
*/

    var irPotential = (((roundedValuation / this.currentPrice) * ((1 + valuationRa1) ** this.years)) ** (1 / this.years)) - 1;
    //* 06/04/18 Changed to valuationRa1 from irHighRa1 and irLowRa1 in following 2 formulas
    var IrLow = (((L_BuyRange / this.currentPrice) * ((1 + valuationRa1) ** this.years)) ** (1 / this.years)) - 1;
    var IrHigh = (((H_BuyRange / this.currentPrice) * ((1 + valuationRa1) ** this.years)) ** (1 / this.years)) - 1;     
    var irPractical;

    if (roundedValuation >= this.currentPrice) {
      irPractical = IrHigh;
    } else {
      irPractical = IrLow;
    }

// CREATE BANDS FOR BUY/SELL SPECTRUM

let planPriceDispersion = (((L_BuyRange + H_BuyRange) / 2) - L_BuyRange) / ((L_BuyRange + H_BuyRange) / 2);
let indexedPlanPrice = this.currentPrice;
let foreseeablePriceChange = (((1+irPractical)**1.5)-1);
let priceChangeMomentum = (2*(Math.max(1,Math.min(1.5,(roundedValuation/practicalValuation)))-1));
let highSideAmplifier = foreseeablePriceChange * priceChangeMomentum;

this.lowBuyRange = L_BuyRange
this.highBuyRange = H_BuyRange

this.TransitionPriceS = indexedPlanPrice * (1+(-1.75 * planPriceDispersion))
this.TransitionPrice1 = indexedPlanPrice * (1+(-1.50 * planPriceDispersion))
this.TransitionPrice2 = indexedPlanPrice * (1+(-0.75 * planPriceDispersion))
this.TransitionPrice3 = indexedPlanPrice * (1+(-0.75 * planPriceDispersion))
this.TransitionPrice4 = indexedPlanPrice * (1+(0.00 * planPriceDispersion))
this.TransitionPrice5 = indexedPlanPrice * (1+(1.00 * planPriceDispersion))
this.TransitionPrice6 = indexedPlanPrice * (1+(1.00 * planPriceDispersion)) * (1+highSideAmplifier)
this.TransitionPrice7 = indexedPlanPrice * (1+(1.50 * planPriceDispersion)) * (1+highSideAmplifier)
this.TransitionPriceE = indexedPlanPrice * (1+(1.75 * planPriceDispersion)) * (1+highSideAmplifier)

// end BUY RANGE MODULE    


    //Growth Rates
    // FOR FUTURE
    //var IndustryValuation = (((this.currentSales * ((1 + this.industryG) ** this.years) * (this.futurePM / futureShares) * futurePE)) / ((1 + valuationRa1) ** this.years)) + (this.years * this.eps * this.payout);
    // var Ir_MarketExpected = valuationRa1;
    //var Ir_Industry = (((IndustryValuation / this.currentPrice) * ((1 + valuationRa1) ** this.years)) ** (1 / this.years)) - 1;

    //Treynor Factor
    // FOR FUTURE
    // var TreynorFactor_Practical = ((irPractical - this.rf1) / valuationB) / (this.erp1 / 1);
    // var TreynorFactor_Potential = ((irPotential - this.rf1) / valuationB) / (this.erp1 / 1);

    this.irPotentialGrowthGraphData = []
    for (i = 0; i <= 5; i++){
      const y = ((1 + irPotential)**i) * this.currentPrice;
      this.irPotentialGrowthGraphData.push(y);
    }

    this.irPracticalGrowthGraphData = []
    for (i=0; i<=5; i++){
      const y = ((1 + irPractical)**i) * this.currentPrice;
      this.irPracticalGrowthGraphData.push(y);
    }

    this.irSP500GrowthGraphData = []
    for (i=0; i<=5; i++){
      const y = ((1 + this.ir_SP500)**i) * this.currentPrice;
      this.irSP500GrowthGraphData.push(y);
    }
    
    this.PriceTrendGraphData = []
    for (i=0; i<=5; i++){
      const y = ((1 + this.PriceTrend)**i) * this.currentPrice;
      this.PriceTrendGraphData.push(y);
    }

    var potentialG = valuationG;
    // var marketExpectedG = this.priceG;
    //var Potential_g = this.round((((futureSales / this.currentSales) ** (1 / this.years)) - 1), 2);
    //var MarketExpected_g = this.round(((((this.currentPrice - (this.years * this.eps * this.payout)) * (ra2 / (1 + ra2)) * ((1 + ra1) ** this.years) * (futureShares / this.futurePM)) / this.currentSales) ** (1 / this.years)) - 1, 2);

    //Graphing of Sales Growth
    
    /*
    Exponential extrapolation, y=m^x * b  Use this as the default.
    Logarithmic extrapolation, y=(m)ln(x) + b
    Linear extrapolation, y=mx + b
    */

    // CurrentSales is b
    var practicalGFutureSales = intraYearSales * ((1 + practicalG)** this.years);
    var potentialGFutureSales = intraYearSales * ((1+potentialG)** this.years);
    var industryGFutureSales = intraYearSales * ((1+this.industryG)**this.years);
    var sp500GFutureSales = intraYearSales * ((1+ this.sP500_g) ** this.years);

    // Slope is m.  Only calculating slope for exponential
    this.practicalGSlope = (practicalGFutureSales/intraYearSales)**(1/this.years);
    this.potentialGSlope = (potentialGFutureSales/intraYearSales)**(1/this.years);;

    // Industry Growth
    this.industryGSlope = (industryGFutureSales/intraYearSales)**(1/this.years);
    //var marketExpectedGSlope = (marketExpectedGFutureSales/CurrentSales)**(1/Years);;

    // SP500 Growth
    this.sp500GSlope = (sp500GFutureSales/intraYearSales)**(1/this.years);

    // Data points for Growth Graph - Exponential extrapolation (y=m^x * b)

    this.practicalGrowthGraphData = [];
    for (i=0; i<=5; i++){
      y = (this.practicalGSlope**i)*intraYearSales;
      this.practicalGrowthGraphData.push(y);
    }

    this.potentialGrowthGraphData = [];
    for (i=0; i<=5; i++){
      y = (this.potentialGSlope**i)*intraYearSales;
      this.potentialGrowthGraphData.push(y);
    }

    this.sp500GrowthGraphData = [];
    for (i=0; i<=5; i++){
      y = (this.sp500GSlope**i)*intraYearSales;
      this.sp500GrowthGraphData.push(y);
    }
    
    this.SalesTrendGraphData = [];
    for (i=0; i<=5; i++){
      y = ((1 + this.SalesTrend)**i)*intraYearSales;
      this.SalesTrendGraphData.push(y);
    }
    
    this.SalesYoYGraphData = [];
    for (i=0; i<=5; i++){
      y = ((1+this.SalesYoY)**i)*intraYearSales;
      this.SalesYoYGraphData.push(y);
    }

    this.PriceYoYGraphData = []
    for (i=0; i<=5; i++){
      y = ((1 + this.PriceYoY)**i) * this.currentPrice;
      this.PriceYoYGraphData.push(y);
    }

    //Graphing of Certainty Normal Curve
    /*
    Plotting a bell (Gaussian) curve in d3 -- http://bl.ocks.org/phil-pedruco/88cb8a51cdce45f13c7e

    if (CurrentPrice < roundedValuation) {
        if (H_BuyRange = roundedValuation){
            Practical_b = valuationB;
        } else {
            Practical_b = H_BuyRange_b;
        } else if (L_BuyRange = roundedValuation);
            if (L_BuyRange = roundedValuation){
                Practical_b = valuationB;
            } else {
                Practical_b = L_BuyRange_b;
            }
        }
    var Potential_b = Valuation_b;
    var g_StdDev = Practical_b * Rm_StdDev;
    var g_Mean = Potential_g;
    var Rm_Mean_PDF = NORM.DIST(Rm_Mean,Rm_Mean,Rm_StdDev); //What is this in Javascript??

    var NormalGraphData = [];
    for (i=-3.9, i<=3.9, i+=.1){
        x = g_Mean + (i * g_StdDev);
        y = NORM.DIST(x(z),g_Mean, g_StdDev)/Rm_Mean_PDF;
        NormalGraphData.push({Xpoint: x, Ypoint: y});
    }

    for(i=0; i<NormalGraphData.length; i++){
       console.log("Xpoint:- "  + NormalGraphData[i].Xpoint + " Ypoint:- "  + NormalGraphData[i].Ypoint);
      }
    */
    //end GRAPHS and IR MODULE

    // FINAL OUTPUT
    // console.log('value', preciseValuation);


    this.irPractical = irPractical;
    this.irPotential = irPotential;
    this.practicalValuation = practicalValuation;
    this.practicalG = practicalG;
    this.potentialG = potentialG;
    this.marketImpliedSalesGrowth = marketImpliedSalesGrowth;

    this.pmGrowth = pmGrowth;
    this.analystsGrowth = this.analystsGrowth;
    this.earningsGrowth = earningsGrowth;
    this.futureR = futureR;
    this.futureCoE = futureCoE;
    this.futureEarningsGrowth = futureEarningsGrowth;
    this.futureRf = futureRf;
    
 
    return roundedValuation
  }
  

  buyRange = () => {
    // MY CONTRACTS MODULE
    return {
      transitionPriceS: this.TransitionPriceS,
      transitionPrice1: this.TransitionPrice1,
      transitionPrice2: this.TransitionPrice2,
      transitionPrice3: this.TransitionPrice3,
      transitionPrice4: this.TransitionPrice4,
      transitionPrice5: this.TransitionPrice5,
      transitionPrice6: this.TransitionPrice6,
      transitionPrice7: this.TransitionPrice7,
      transitionPriceE: this.TransitionPriceE
    }
  }

  update = (growth, PM, PE) => {
    this.userGrowthFactor = growth;
    this.userPMFactor = PM;
    this.userPEFactor = PE;
  }

  graphData = () => {
    return {
      irPotentialGrowthGraphData: this.irPotentialGrowthGraphData,
      irPracticalGrowthGraphData: this.irPracticalGrowthGraphData,
      irSP500GrowthGraphData: this.irSP500GrowthGraphData,
      practicalGrowthGraphData: this.practicalGrowthGraphData,
      potentialGrowthGraphData: this.potentialGrowthGraphData,
      sp500GrowthGraphData: this.sp500GrowthGraphData,
      PriceTrendGraphData: this.PriceTrendGraphData,
      SalesTrendGraphData: this.SalesTrendGraphData,
      SalesYoYGraphData: this.SalesYoYGraphData,
      PriceYoYGraphData: this.PriceYoYGraphData
    }
  }

  priceMomentum = () => {
    return (this.currentPrice / this.price13W) / (this.currentPriceIVV / this.price13WIVV)
  }

  round(number, precision) {
    const factor = 10 ** precision;
    const output = Math.round(number * factor) / factor;

    return output;
  }

  Ra(Beta, ERP, Rf) {
    return Rf + (Beta * ERP);
  }

  Beta(Beta, DOR, RB) { //This dampens stage2 Beta
    // return Beta * (1 - DOR) + (DOR * RB)
    return Beta + (DOR * (RB - Beta));
  }

  Dampen_EarningsGrowth(g1, plowback, NumAnalysts, LowGrowth, HighGrowth, LastMonthGrowth, gm, eps, BuyBackYield, ra1, ReversionGrowth) {
    //Replaced input parameter DegreeReversion_MarketImpliedEarningsGrowth with BuyBackYield

    /*Joint Harvard/MIT study concluded consensus analyst forecasts off by 31.3%.
       McKinsey study determined average earnings of 6%, but average analyst forecasts a year earlier nearly twice as high, significantly falling just before a company announces earnings
   */

    //First need to calculate ConfidenceInAnalysts and normalizedPlowback values that will be used later in function

    var confidenceInAnalysts;

    //Confidence in consensus Analysts Growth estimate from Reuters
    //Confidence scaled based on number of analysts

    if (NumAnalysts <= 1) {
      confidenceInAnalysts = 0; //total loss in confidence
    } else if (NumAnalysts === 2) {
      confidenceInAnalysts = 0.33;
    } else if (NumAnalysts === 3 || NumAnalysts === 4) {
       confidenceInAnalysts = 0.66;
    } else if (NumAnalysts >= 5) {
      confidenceInAnalysts = 1;
    }
  
    //Total loss of confidence in consensus Analysts Growth estimate because of wide range of growth estimates

    if ((Math.abs(HighGrowth - LowGrowth) > (0.5 * HighGrowth)) || (Math.abs(g1 - LastMonthGrowth) > (0.5 * g1))) {
      confidenceInAnalysts = 0;
    }

    //Adjust Retention to be between 0 and 1 - normalize
    //stable companies should be between 0-1; but for a few "shaky" companies, need to normalize plowback.
    //Assume Buyback equals moderate Payout. Normalize between 0 and 1.

    var payout = 1 - plowback;
    var normalizedPlowback;

    if (payout < 0.4) {
      normalizedPlowback =  1 - (1.5 * payout)        //  Approximate Distribution.  Actual Distribution = Plowback + Buyback where Buyback = (-ShrTrend)(Price)/EPS1.
    } else {
      normalizedPlowback = 1 -(1 *  payout)
    }
    
    normalizedPlowback = Math.min(1, Math.max(0, normalizedPlowback));

    // REASONABLE GROWTH          for normalized Plowback
    //Confidence in Analysts consensus Growth estimates NOT taken into account.
    /*Check to see if g1 is reasonable growth based on normalized plowback.  Typical earnings growths for companies range from 5 to 10%.  Typical project investment returns are 10-20%.
       valuation formula assumes company’s projects return a fixed return (r1) in Stage 1 and fixed return (r2) in stage 2.  A stage is defined as the period the same project return is earned.
       Since project returns don’t vary during a stage, only way to grow earnings is to plowback earnings.
       growth = (project return)(plowback percentage).  Example:  company earns an average of 12% on project investments.  Every year they plowback 40% of earnings.  Earnings will grow (.12)(.40) = 4.8%.
    */

    var dampenGrowth;

    if (g1 <= 0.06) {
        dampenGrowth = g1;
    } else if ((g1 <= .08) && (normalizedPlowback >= .25)  && (BuyBackYield <= 0.1)) {   //Growth requires plowback, for growth less than 8% requires at least 25% retention.
         dampenGrowth = g1;
    } else if ((g1 <= .12) && (normalizedPlowback >= .4) && (BuyBackYield <= 0.05)) {      //Growth requires plowback, for growth between 08-12% requires at least 40% retention.
         dampenGrowth = g1;
    } else if ((g1 <= .16) && (normalizedPlowback >= .6) && (BuyBackYield <= 0.025)) {     //Growth requires plowback, for growth between 12-16% requires at least 60% retention. 
         dampenGrowth = g1;
    }  else {

      // UNREASONABLE GROWTH        for normalized Plowback
      // Confidence in Analysts consensus Growth estimate taken into account.
      //Growth Forecast Lag - tendency for Analysts growth forecasts to be "mismatched" (180 out of sync) with interest rate changes
      /*g1 unreasonable growth, use James-Stein formula to push g1 towards a more reasonable growth = (10%)(normalizedPlowback).
         In general, growth = (return on projects)(plowback). Brian says 10% (.1) is a typical growth of earnings. 
      */

      // Fairly confident in analysts consensus estimate.  If very confident (1), assume many analysts whose Rf1 estimates negate each other

      if ((confidenceInAnalysts > 0) && (confidenceInAnalysts <= .66) && (this.rf1 < .035)) {
        g1 = g1 - .025         // If Rf1 is  low, Analysts growth estimates too high (180 out of sync with economy) for downbeat economy that  lower Rf1 intended to invigorate.
      }
      if ((confidenceInAnalysts > 0) && (confidenceInAnalysts <= .66) && (this.rf1 > .07)) {
        g1 = g1 + .025         // If Rf1 is high, Analysts growth estimates too  low (180 out of sync economy) for   upbeat economy that higher Rf1 intended to subdue.
      }

      // g1 dampened using James-Stein Estimator.
      dampenGrowth = ReversionGrowth + (confidenceInAnalysts * (g1 - ReversionGrowth));
      dampenGrowth = Math.min(g1,dampenGrowth);                              
    }

    //Sanity checks - governor, humility, safety net
  
    //GOVERNOR
    /*Equilg1 is function parameter.  Equilg1 = (equil return, re, on projects)(plowback).
       It is the expected growth if company projects return as market expects for level of risk taken.
       Growth over 4 times Equilg1 is considered excessive, thus reduced to 4 x Equilg1
    */

    dampenGrowth = Math.min(dampenGrowth, Math.max(0, 4 * ra1 * normalizedPlowback));

    //HUMILITY (aka waffling). Push growth towards market implied growth, gm, based on current price.  Compensate for growth forecast difference from Market gm.

    var Towards_gm;

    if ((eps > 0) && (gm !== 0)) {

    if ((Math.abs(dampenGrowth - gm)/Math.abs(dampenGrowth)) < .25) {              
        Towards_gm = 0.4;                                                        // Small difference in growth expectations
    } else if ((Math.abs(dampenGrowth - gm)/Math.abs(dampenGrowth)) < .5) {  
        Towards_gm = 0.3;                                                        // Moderate difference in growth expectations
    } else if ((Math.abs(dampenGrowth - gm)/Math.abs(dampenGrowth)) < 1) {      
        Towards_gm = 0.2;                                                        // Large difference in growth expectations
    } else if ((Math.abs(dampenGrowth - gm)/Math.abs(dampenGrowth)) < 2) {      
         Towards_gm = 0.1;                                                       // Enormous difference in growth expectations
    }  else {
         Towards_gm = 0;                                                         // Radical difference in growth expectations, ignore.  Likely from inappropriate PM or PE.
    }
//    Towards_gm = 0                                                                                               // Line typically commented out.  Uncomment to turn off gm adjustment.
    dampenGrowth = dampenGrowth - (Towards_gm * (dampenGrowth - gm));       // Knudge towards gm
    }

    //SAFETY NET - prevents outrageous growth estimate from being used.  Further cap growth above 16%.

    if (dampenGrowth > 0.16) {
      dampenGrowth = .8 * dampenGrowth;                                                             
    }                                       // Margin of Safety (POS) for positive forecasted earnings growth
                                            //Analyst forecasts typically off by more than 30%
    return dampenGrowth;
  } 
  //end Dampen_EarningsGrowth function
  
  determinationCoefficient(data, results) {
    const predictions = [];
    const observations = [];

    data.forEach((d, i) => {
      if (d[1] !== null) {
        observations.push(d);
        predictions.push(results[i]);
      }
    });

    const sum = observations.reduce((a, observation) => a + observation[1], 0);
    const mean = sum / observations.length;

    const ssyy = observations.reduce((a, observation) => {
      const difference = observation[1] - mean;
      return a + (difference * difference);
    }, 0);

    const sse = observations.reduce((accum, observation, index) => {
      const prediction = predictions[index];
      const residual = observation[1] - prediction[1];
      return accum + (residual * residual);
    }, 0);

    return 1 - (sse / ssyy);
  }

  linear(data, precision) {
    const sum = [0, 0, 0, 0, 0];
    let len = 0;

    for (let n = 0; n < data.length; n++) {
      if (data[n][1] !== null) {
        len++;
        sum[0] += data[n][0];
        sum[1] += data[n][1];
        sum[2] += data[n][0] * data[n][0];
        sum[3] += data[n][0] * data[n][1];
        sum[4] += data[n][1] * data[n][1];
      }
    }

    const run = ((len * sum[2]) - (sum[0] * sum[0]));
    const rise = ((len * sum[3]) - (sum[0] * sum[1]));
    const gradient = run === 0 ? 0 : this.round(rise / run, precision);
    const intercept = this.round((sum[1] / len) - ((gradient * sum[0]) / len), precision);

    const predict = x => ([
      this.round(x, precision),
      this.round((gradient * x) + intercept, precision)
    ]);

    const points = data.map(point => predict(point[0]));

    return {
      points,
      predict,
      equation: [gradient, intercept],
      r2: this.round(this.determinationCoefficient(data, points), precision),
      string: intercept === 0 ? `y = ${gradient}x` : `y = ${gradient}x + ${intercept}`,

    }
  }

  exponential(data, precision) {
    const sum = [0, 0, 0, 0, 0, 0];

    for (let n = 0; n < data.length; n++) {
      if (data[n][1] !== null) {
        sum[0] += data[n][0];
        sum[1] += data[n][1];
        sum[2] += data[n][0] * data[n][0] * data[n][1];
        sum[3] += data[n][1] * Math.log(data[n][1]);
        sum[4] += data[n][0] * data[n][1] * Math.log(data[n][1]);
        sum[5] += data[n][0] * data[n][1];
      }
    }

    const denominator = ((sum[1] * sum[2]) - (sum[5] * sum[5]));
    const a = Math.exp(((sum[2] * sum[3]) - (sum[5] * sum[4])) / denominator);
    const b = ((sum[1] * sum[4]) - (sum[5] * sum[3])) / denominator;
    const coeffA = this.round(a, precision);
    const coeffB = this.round(b, precision);
    const predict = x => ([
      this.round(x, precision),
      this.round(coeffA * Math.exp(coeffB * x), precision),
    ]);

    const points = data.map(point => predict(point[0]));

    return {
      points,
      predict,
      equation: [coeffA, coeffB],
      string: `y = ${coeffA}e^(${coeffB}x)`,
      r2: this.round(this.determinationCoefficient(data, points), precision),
    }
  }

  logarithmic(data, precision) {
    const sum = [0, 0, 0, 0];
    const len = data.length;

    for (let n = 0; n < len; n++) {
      if (data[n][1] !== null) {
        sum[0] += Math.log(data[n][0]);
        sum[1] += data[n][1] * Math.log(data[n][0]);
        sum[2] += data[n][1];
        sum[3] += (Math.log(data[n][0]) ** 2);
      }
    }

    const a = ((len * sum[1]) - (sum[2] * sum[0])) / ((len * sum[3]) - (sum[0] * sum[0]));
    const coeffB = this.round(a, precision);
    const coeffA = this.round((sum[2] - (coeffB * sum[0])) / len, precision);

    const predict = x => ([
      this.round(x, precision),
      this.round(this.round(coeffA + (coeffB * Math.log(x)), precision), precision),
    ]);

    const points = data.map(point => predict(point[0]));

    return {
      points,
      predict,
      equation: [coeffA, coeffB],
      string: `y = ${coeffA} + ${coeffB} ln(x)`,
      r2: this.round(this.determinationCoefficient(data, points), precision),
    }
  }

  /*Sales extrapolation method applied to recent past sales trend.  Significant factor in Top Line valuation.
              Note: Exponential extrapolation will be the default!!
              Exponential extrapolation (Hypergrowth mode) y=m^x * b
              Logarithmic extrapolation (Startup mode) y=(m)ln(x) + b
              Linear extrapolation (Mature company mode) y=mx + b

  source: A javascript library containing a collection of least squares fitting methods https://github.com/Tom-Alexander/regression-js
  */

 BuyRange_Price_g(price, ra1, futurePE, eps, years, payout, currentSales, futureShares, futurePM, valuationG,priceRangeStep) {
  
  var bestFitG

    bestFitG = (((price - (years * eps * payout)) * ((1 + ra1) ** years) * futureShares / (futurePM * futurePE * currentSales)) ** (1 / years)) - 1;
    
    //04/08/20 new best fit code

  var Bound1_g 
  var Bound2_g 
  var Bound1_Price
  var Bound2_Price

    var denominator
      if (priceRangeStep === .03) {
        denominator = 3;
      } else {
        denominator = 2;
      }

    Bound1_g = this.round(this.round(bestFitG, 2) - (0.01 * ((100 * Math.sign(bestFitG) * this.round(Math.abs(bestFitG), 2)) % denominator)), 2)
  
    Bound2_g = Bound1_g + (Math.sign(Bound1_g) * priceRangeStep)   
  
    Bound1_Price = (years* eps * payout) + (((((((1 + Bound1_g) ** years) * currentSales) * futurePM) / futureShares) * futurePE) / ((1 + ra1) ** years))
  
    Bound2_Price = (years * eps * payout) + (((((((1 + Bound2_g) ** years) * currentSales) * futurePM) / futureShares) * futurePE) / ((1 + ra1) ** years))
        
var Bound1_EvenOdd
var Bound2_EvenOdd
var Scenario

  Bound1_EvenOdd = 1 * (Math.abs(100 * Bound1_g) % 2)
  Bound2_EvenOdd = 2 * (Math.abs(100 * Bound2_g) % 2)

  Scenario = Bound1_EvenOdd + Bound2_EvenOdd
  if ((Scenario === 0) && (Math.abs(price - Bound1_Price) > Math.abs(price - Bound2_Price))) {
    Scenario = 4
  }

  if ((Scenario === 1) || (Scenario ===4)) {
    bestFitG = Bound2_g
  } else {
    bestFitG = Bound1_g
  }
  
   return bestFitG

  } //end of BuyRange_Price_g function

  SalesGrowthStepAlign(gs) {
    var stepper
      if (Math.abs(gs) > .3) 
      {
        stepper =  Math.max(.33, .03 * Math.floor(Math.abs(gs)/.03));
      } 
      else if (Math.abs(gs) > .15)
      {
        stepper =  Math.max(.18,.02 * Math.floor(Math.abs(gs)/.02));
      } 
      else {
        stepper = Math.abs(gs)
      }
      return this.round(Math.sign(gs) * stepper, 2)
    }
      
  DateDiff(datepart, fromdate, todate) {
    datepart = datepart.toLowerCase();
    // datepart: 'y', 'm', 'w', 'd', 'h', 'n', 's'
    var diff = todate - fromdate;
    var divideBy = {
      w: 604800000,
      d: 86400000,
      h: 3600000,
      n: 60000,
      s: 1000
    };

    return Math.floor(diff / divideBy[datepart]);
  }
}

// Export the valuation class
export default Valuation



// WEBPACK FOOTER //
// ./src/valuation/main.js